<template>
    <div class="selected-preset-info">
        <div class="preset-details">
            <h4>{{ preset.label }}</h4>
            <p v-if="preset.caption">{{ preset.caption }}</p>
            <div class="preset-meta d-flex justify-content-between">
                <span class="preset-category">{{ getCategoryLabel(preset.category) }}</span>
                <span v-if="preset.isFree" class="api-key-indicator">
                    <font-awesome-icon :icon="['fa-solid', 'fa-sparkles']" />
                    Free
                </span>
                <span v-else class="api-key-indicator">
                    <font-awesome-icon :icon="['fa-solid', 'fa-key']" />
                    Requires API Key
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { PresetCategory } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { PRESET_CATEGORIES } from '@/components/DesignStudio/ImageEffectsProperties/core/presets';

defineProps<{
    preset: ImageEffectPreset;
}>();

const getCategoryLabel = (category: PresetCategory): string => {
    const categoryInfo = PRESET_CATEGORIES.find((cat) => cat.category === category);
    return categoryInfo?.label || category;
};
</script>

<style scoped lang="scss">
.selected-preset-info {
    padding: 16px;
    text-align: left;

    .preset-details {
        h4 {
            margin: 0 0 8px;
        }

        p {
            margin: 0 0 12px;
            font-size: 14px;
        }

        .preset-meta {
            gap: 12px;

            .preset-category {
                background: var(--primary-purple);
                color: white;
                padding: 2px 6px;
                border-radius: 4px;
                font-size: 11px;
                font-weight: 500;
                text-transform: uppercase;
            }

            .api-key-indicator {
                display: flex;
                align-items: center;
                gap: 4px;
                font-size: 12px;
                font-weight: 500;
            }
        }
    }
}
</style>
